import {Injectable} from "@angular/core";

const url = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCj_pOr2SdN8jnpZ0Qms0DMLJRI89xqYQI&callback=mapLoaded';

declare var google:any;

@Injectable()
export class GoogleMapsLoader {

  private static promise;

  public static load(){

    // google marker
    // var markerG,
    //   markerT,
    //   map;
    //
    // var markerOne,
    //   markerTwo,
    //   mapOne,
    //   mapTwo;
    //
    // function initMap() {
    //   map = new google.maps.Map(document.getElementById('map'), {
    //     zoom: 13,
    //     center: {lat: 42.847780, lng: 25.338839}
    //   });
    //
    //   markerG = new google.maps.Marker({
    //     map: map,
    //     draggable: true,
    //     animation: google.maps.Animation.DROP,
    //     position: {lat: 42.847753, lng: 25.338837}
    //   });
    //
    //   markerT = new google.maps.Marker({
    //     map: map,
    //     draggable: true,
    //     animation: google.maps.Animation.DROP,
    //     position: {lat: 43.265025, lng: 26.578212}
    //   });
    //
    //   markerG.addListener('click', toggleBounceG);
    //   markerT.addListener('click', toggleBounceT);
    //
    //   // maps
    //   mapOne = new google.maps.Map(document.getElementById('mapOne'), {
    //     zoom: 17,
    //     center: {lat: 42.847780, lng: 25.338839}
    //   });
    //
    //   mapTwo = new google.maps.Map(document.getElementById('mapTwo'), {
    //     zoom: 17,
    //     center: {lat: 43.264899, lng: 26.578274}
    //   });
    //
    //   markerOne = new google.maps.Marker({
    //     map: mapOne,
    //     draggable: true,
    //     animation: google.maps.Animation.DROP,
    //     position: {lat: 42.847753, lng: 25.338837}
    //   });
    //
    //   markerTwo = new google.maps.Marker({
    //     map: mapTwo,
    //     draggable: true,
    //     animation: google.maps.Animation.DROP,
    //     position: {lat: 43.265025, lng: 26.578212}
    //   });
    // }
    //
    // function toggleBounceG() {
    //   if (markerG.getAnimation() !== null) {
    //     markerG.setAnimation(null);
    //   } else {
    //     markerG.setAnimation(google.maps.Animation.BOUNCE);
    //   }
    // }
    //
    // function toggleBounceT() {
    //   if (markerT.getAnimation() !== null) {
    //     markerT.setAnimation(null);
    //   } else {
    //     markerT.setAnimation(google.maps.Animation.BOUNCE);
    //   }
    // }
    //
    // window['initMap'] = initMap;
    //
    // let node = document.createElement('script');
    // node.src = url;
    // node.type = 'text/javascript';
    // document.getElementsByTagName('head')[0].appendChild(node);

    // First time 'load' is called?
    if (!GoogleMapsLoader.promise) {

      // Make promise to load
      GoogleMapsLoader.promise = new Promise( resolve => {
        // Set callback for when google maps is loaded.
        window['mapLoaded'] = (ev) => {
          resolve('google maps api loaded');
        };

        let node = document.createElement('script');
        node.src = url;
        node.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(node);
      });
    }

    // Always return promise. When 'load' is called many times, the promise is already resolved.
    return GoogleMapsLoader.promise;
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/shared/map-loader.service.ts